import { get } from "./http.service";

const UserTemplateService = {
    getMarketDetails: () => get(`outlookProfile`),
};

export default UserTemplateService;
